export enum LeadRoutes {
    invite = 'invite',
    duplicated = 'duplicated',
    archive = 'archive',
    manager = 'manager',
}
